export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_05.468ba327.png";